import { render, staticRenderFns } from "./TabbedModalItem.vue?vue&type=template&id=d00581b4"
import script from "./TabbedModalItem.vue?vue&type=script&lang=js"
export * from "./TabbedModalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports